export function formatBaht(
  value,
  locale = 'th-TH',
  currency = 'THB',
  maximumFractionDigits = 2
) {
  const numberValue = Number(value);

  if (Number.isNaN(numberValue)) {
    return undefined;
  }

  const formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits
  });

  return formatter.format(numberValue);
}

export function removeNonNumericCharacters(value) {
  return value.replace(/[^0-9.]/g, '');
}

export function handleInputValidation(event, value) {
  const { key } = event;
  const valueParts = value.split('.');

  // Allow only numbers, decimal point, and backspace
  if (!/[0-9.]|Backspace/.test(key)) {
    event.preventDefault();
    return;
  }

  if (value !== '' && value.includes('.')) {
    // Prevent entering a second decimal point
    if (key === '.' && valueParts.length > 1) {
      event.preventDefault();
      return;
    }

    // Prevent entering more than two decimal places after decimal point
    if (valueParts[1].length >= 2) {
      event.preventDefault();
    }
  }
}
